export class Settings {
    usuario: string;
    pocaeBackend: string;
    pocaeHistorial: string;
    Soap: string;
    solicitud: string;
    ipFyService: string;
    abt: string;
    admService: string;
    turnstileSiteKey: string;
}
